import { render, staticRenderFns } from "./applyDetail.vue?vue&type=template&id=578bd4bc&scoped=true"
import script from "./applyDetail.vue?vue&type=script&lang=js"
export * from "./applyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578bd4bc",
  null
  
)

export default component.exports